'use strict';

import TextSplit from './TextSplit';
import LetterTextSplit from './LetterTextSplit';

module.exports = {
  TextSplit,
  LetterTextSplit
};



// WEBPACK FOOTER //
// ./custom_modules/react-text-split/src/index.js